import { COLOR_YELLOW_600 } from '@alltrails/denali/tokens';
import { createParkPinSvg } from './svgMarkerComponents';

const nationalParkPinSvg = createParkPinSvg('national-park-pin', COLOR_YELLOW_600);

export default nationalParkPinSvg;
